<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="22"
            :lg="22"
          >
          <Divider orientation="left">{{langMap.serviceList[lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="2"
            :lg="2"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{langMap.search[lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="resourcesCol"
        :data="list"
      ></Table>
      <!--分页数据-->
    </Card>
  </div>

</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 260,
      list: [],
      //表格
      tableLoading: false,
      timer: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    resourcesCol() {
      return [
        {
          title: "#",
          key: "index",
          width: 60,
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: this.langMap.belongService[this.lang],
          minWidth: 120,
          key: "server"
        },
        {
          title: this.langMap.cluster[this.lang],
          minWidth: 120,
          key: "clusterName"
        },
        {
          title: this.langMap.instance[this.lang],
          minWidth: 120,
          key: "instanceId"
        },
        {
          title: this.langMap.serviceName[this.lang],
          minWidth: 120,
          key: "serviceName"
        },
        {
          title: "IP",
          minWidth: 120,
          key: "ip"
        },
        {
          title: this.langMap.port[this.lang],
          minWidth: 120,
          key: "port"
        },
        {
          title: this.langMap.weight[this.lang],
          minWidth: 80,
          key: "weight"
        },
        {
          title: this.langMap.healthStatus[this.lang],
          minWidth: 80,
          key: "healthy",
          render(h, params) {
            var text = "";
            var color = "";
            if (params.row.healthy) {
              text = this.langMap.normal[this.lang];
              color = "green";
            } else if (params.row.healthy) {
              text = this.langMap.abnormal[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: this.langMap.isEnabled[this.lang],
          minWidth: 80,
          key: "enabled"
        },
        {
          title: this.langMap.temporaryInstance[this.lang],
          minWidth: 80,
          key: "ephemeral"
        }
      ]
    }
  },
  methods: {
    //获取产品
    getList() {
      this.tableLoading = true;
      api.getData("system-server/server/list", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: this.langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.list = res.data;
        }
        this.tableLoading = false;
      });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getList();
        }, 10000);
        // 在beforeDestroy钩子触发时清除定时器
        this.$once("hook:beforeDestroy", () => {
          clearInterval(this.timer);
        });
      }
    }
  },
  created() {
    this.getList();
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    //clearInterval(this.timer)
    //this.timer = null
    //this.setTimer()
  },
  destroyed: function() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style>
</style>
